// 一般值
const values = {
  must: '必填',
  choose: '选填',
  or: '或',
  colon: '：',
  comma: '，',
  multiply: '×',
  null: '--',
  yes: '是',
  no: '否',
  nodata: '暂无数据！'
}

// 常用操作
const actions = {
  all: '全部',
  auto: '自动',
  add: '添加',
  create: '新建',
  found: '创建',
  increase: '新增',
  edit: '编辑',
  modify: '修改',
  del: '删除',
  agree: '同意',
  confirm: '确认',
  ok: '确定',
  cancel: '取消',
  close: '关闭',
  save: '保存',
  submit: '提交',
  update: '更新',
  browse: '浏览',
  look: '查看',
  preview: '预览',
  upload: '上传',
  download: '下载',
  login: '登录',
  loging: '使用已有账户登录',
  logout: '注销',
  reg: '注册',
  simpleReg: '快速注册',
  pre: '上一步',
  next: '下一步',
  more: '更多',
  search: '搜索',
  query: '查询',
  select: '选择',
  selectall: '全选',
  unselectall: '全不选'
}

// 排序
const sorts = {
  name: '名称',
  size: '大小',
  time: '修改日期',
  desc: '降序',
  asc: '升序'
}

// 翻页
const pagination = {
  total: '共{0}条',
  first: '首页',
  prev: '上一页',
  next: '下一页',
  end: '尾页',
  size: '条/页',
  jump: '跳至',
  page: '页'
}

// 一般消息
const message = {
  name: '消息',
  title: {
    alert: '警告',
    confirm: '确认',
    info: '提示',
    prompt: '输入'
  },
  field: {
    from: '发信人'
  },
  content: {
    confirm: '您确定要%吗？',
    doing: '正在努力加载，请稍后……',
    error: '%失败，请稍后重试！',
    disformat: '%格式不正确！',
    ignore: '没有%，确定要放弃吗？',
    input: '请输入%',
    select: '请选择%',
    success: '%成功！',
    textover: '最多输入%个字',
    undo: '您还没有%！',
    unsave: '您有信息还未保存，确定要离开页面吗？',
    unstore: '操作不能恢复，您确定%吗？',
    wrong: '%输入有误！'
  }
}

// 距离时间
const leavesDate = {
  second: '刚刚',
  minute: '{0}分钟前',
  hour: '{0}小时前',
  day: '{0}天前',
  month: '{0}月前',
  year: '{0}年前'
}

export {
  values, // 一般值
  actions, // 常用操作
  sorts, // 排序
  pagination, // 翻页
  message, // 一般消息
  leavesDate // 距离时间
}



// WEBPACK FOOTER //
// ./src/commons/locale/charset/zh_cn/common.js